import { Table } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { FormatCurrency } from "../../common/Constants";
import moment from "moment";

export const OngoingTable = ({ data, pagePermission }) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Application ID",
      dataIndex: "application_uniqueId",
      key: "application_uniqueId",
      width: 180,
      render: (text, record) => (
        <div className="make-model-block">
          <p>{`${text}`}</p>
          <h2>{`${record?.agent_info?.name}`}</h2>         
          <p>{`${record?.ongoing_data?.disbursement_date}`}</p>
        </div>
      ),
    },
    {
      title: "Flooring Type",
      dataIndex: "flooring_product",
      key: "flooring_product",
      width: 140,
      render: (flooringType) => (
        <div className="table-info-block">
          <span>{flooringType}</span>
        </div>
      ),
    },
    {
      title: "Veh/Chassis No",
      dataIndex: "vehicle_reg_no",
      key: "vehicle_reg_no",
      width: 130,
      render: (vehChassisNo, item) => (
        <div className="ven-block">
          <h2>{`${vehChassisNo}`}</h2>
          <p>{`${item.chassis_no}`}</p>
        </div>
      ),
    },
    {
      title: "Make/Model",
      dataIndex: "make_model",
      key: "make_model",
      width: 200,
      render: (makeModel) => (
        <div className="make-model-block">
          <h2>{`${makeModel}`}</h2>
        </div>
      ),
    },
    {
      title: "Int. per 30 days",
      dataIndex: "ongoing_data",
      key: "ongoing_data",
      width: 120,
      render: (ongoing_data) => (
        <div>
          <span>{FormatCurrency(ongoing_data?.floor_interest)}%</span>
        </div>
      ),
    },
    {
      title: "Floor Amt.",
      dataIndex: "ongoing_data",
      key: "ongoing_data",
      width: 120,
      render: (ongoing_data) => (
        <div>
          <span>${FormatCurrency(ongoing_data?.intended_floor_amount)}</span>
        </div>
      ),
    },
    {
      title: "Admin Fee",
      dataIndex: "ongoing_data",
      key: "ongoing_data",
      width: 120,
      render: (ongoing_data) => (
        <div>
          <span>${FormatCurrency(ongoing_data?.agent_admin_fee)}</span>
        </div>
      ),
    },
    {
      title: "Total Int. Till Date",
      dataIndex: "ongoing_data",
      key: "ongoing_data",
      width: 120,
      render: (ongoing_data) => (
        <div>
          <span>${FormatCurrency(ongoing_data?.total_interest)}</span>
        </div>
      ),
    },
    {
      title: "Total Amt.  Paid",
      dataIndex: "ongoing_data",
      key: "ongoing_data",
      width: 120,
      render: (TotalAmtPaid) => (
        <div>
          <span>${FormatCurrency(TotalAmtPaid?.total_amount_paid)}</span>
        </div>
      ),
    },
    {
      title: "Redemption Amt.",
      dataIndex: "ongoing_data",
      key: "ongoing_data",
      width: 120,
      render: (RedemptionAmt) => (
        <div>
          <span>${FormatCurrency(RedemptionAmt?.redemption_amount)}</span>
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "OngoingAction",
      key: "OngoingAction",
      width: 125,
      render: (action, item) => (
        <div>
          {pagePermission?.update_permission == 1 && (
            <span
              className="view-resume-block"
              onClick={() => {
                navigate("/flooring-cases/view", {
                  state: {
                    appId: item?.id,
                    submitted_date: item?.submitted_date,
                    expiry_date: item?.expiry_date,
                    isOngoing: true,
                    pagePermission: pagePermission
                  },
                });
              }}
            >
              <EyeOutlined className="mt-1" />
              <span>View</span>
            </span>
          )}
          {/* {pagePermission?.delete_permission == 1 && (

            <span
              className="table-delete-block"
              
            >
              <DeleteOutlined className="mt-1" />
              <span>Delete</span>
            </span>
          )} */}
        </div>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      scroll={{ x: "calc(700px + 50%)", y: 500 }}
    />
  );
};
